import React from 'react';
import '../css/AreasTematicas.css';

function AreasTematicas() {
  return (
<div className="areas-tematicas">
  <h1>Áreas Temáticas</h1>
  <br />
  <ul>
    <li>
      <h2>Calidad e Innovación en la Industria Alimentaria</h2>
      <p>
        Un enfoque en la mejora de la calidad e inocuidad de los alimentos, así como el desarrollo de productos alimentarios innovadores que respondan a las tendencias de consumo actuales.
      </p>
      <p>
        Desarrollo de nuevos productos | Normativa, Calidad de alimentos y Seguridad alimentaria | Nuevas Tendencias Alimentarias
      </p>
    </li>

    <li>
      <h2>Nutrición, Salud y Sostenibilidad</h2>
      <p>
        Relación entre la alimentación y la salud, promoviendo la educación nutricional y el consumo de alimentos que contribuyan a un estilo de vida saludable y sostenible.
      </p>
      <p>
        Vinculación salud y alimentación | Intervenciones educativas en ciencia y tecnología de alimentos | Promoción del consumo de alimentos saludables | Análisis cuantitativo de nutrientes | Reducción de desperdicios | Accesibilidad a alimentos saludables | Influencia de factores ambientales, sociales, económicos y políticos en la producción de alimentos
      </p>
    </li>

    <li>
      <h2>Tecnología Alimentaria y de Procesos</h2>
      <p>
        Desarrollo de procesos y tecnologías que transforman la producción, conservación y distribución de alimentos.
      </p>
      <p>
        Alimentos fermentados y microbiología de los alimentos | Biotecnología de alimentos | Conservación, almacenamiento y distribución sostenible | Modelado matemático, simulación y optimización de procesos de la industria alimentaria | Internet de las Cosas (IoT), IA aplicada a la industria de alimentos, e Industria 4.0 | Nanotecnología
      </p>
    </li>
  </ul>
</div>



  );
}

export default AreasTematicas;
